<template>
  <div
    :class="`position-${position} icon-count ${classBackgroundColor}`"
    :data-qa="`icon-count-${icon}`"
    :style="backgroundColor ? { '--back-color': backgroundColor } : {}"
    @click="handleClick">
    <sIcon
      :color="iconColor"
      :type="icon"/>
    <span
      class="h7-text ml-1"
      :class="textClass"
      data-qa="icon-count-value">{{ count }}</span>
  </div>
</template>
<script>
/**
 * Простой компонента Иконка+цифра
 * @vue-prop {String} icon - Иконка (тип из общего компонента)
 * @vue-prop {String, Number} count - Количество
 * @vue-prop {String} iconColor - Цвет иконки
 * @vue-prop {String} textClass - класс количества
 */
export default {
  name: 'iconCount',
  computed: {
    classBackgroundColor() {
      return this.backgroundColor ? 'is-background-color' : ''
    }
  },
  props: {
    icon: {
      type: String
    },
    count: {
      type: [String, Number]
    },
    iconColor: {
      type: String,
    },
    backgroundColor: {
      type: String,
    },
    textClass: {
      type: [Object, String],
    },
    position: {
      type: String,
      default: 'right'
    }
  },
  methods: {
    handleClick(event) {
      if (event) { event.stopPropagation() }
      this.$emit('click', event)
    }
  }
}
</script>
<style lang="scss" scoped>
.icon-count {
  display: flex;
  align-items: center;
  gap: 4px;
  &.position-left {
    flex-direction: row-reverse;
  }
  &.is-background-color {
    background-color: var(--back-color);
    border-radius: 4px;
    &:first-child {
      padding: 1px 0 1px 1px;
    }
    &:last-child {
      padding: 1px 1px 1px 0;
    }
  }
}
</style>
